module.exports = __webpack_public_path__ + "img/vertical-align-bottom.dcc80493.svg";